import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import PdfData from './PdfData'
import EditScreens from '../EditScreens'
import LogScreen from '../LogScreen'
import {
  processEditedData,
  showUrlEditModal,
  showEditModal,
  changeProfilePicInitialEditState,
  showLogModal,
} from '../../actions/Edit'
import { updateText } from '../../actions/DetailedFeedback'
import { fetchPdf } from '../../actions/GeneratePdf'
import InfoScreens from '../InfoScreens'
import { Dropdown, OverlayTrigger, Popover } from 'react-bootstrap'
import $ from 'jquery'
import _ from 'underscore'
import classNames from 'classnames'
import {
  notification,
  checkIfEmpty,
  deepCopy,
  checkLinkedinUrlSanity,
} from '../../services/helpers'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from '@vmockinc/dashboard/Common/commonComps/Modal'
import FocusLock, { MoveFocusInside } from 'react-focus-lock'
import 'jquery-highlight'
import { editScreenAriaLabel } from '../Constants/AriaLabelText'
import * as cookie from 'js-cookie'
import moment from 'moment'

const timeOutMilliseconds = 2000

const sectionUnderscore = {
  'Personal Information': 'personal_information',
  'Profile Picture': 'profile_picture',
  Headline: 'headline',
  Summary: 'summary',
  Experience: 'experience',
  Education: 'education',
}

const tabIndexesSequence = {
  personalInformation: {
    name: 11,
    profile_url: 13,
    connections: 15,
  },
}

export const charCountLimit = {
  personal_information: {
    name: 100,
  },
  headline: {
    text: 220,
  },
  summary: {
    text: 2600,
  },
  experience: {
    company: 100,
    title: 100,
    text: 2000,
  },
  education: {
    school: 150,
    degree: 100,
    field_of_study: 100,
    activities_and_societies: 500,
  },
  volunteer_experience: {
    title: 100,
    text: 2000,
  },
  projects: {
    title: 255,
    text: 2000,
  },
  publications: {
    title: 255,
    text: 2000,
  },
}

class ProfileData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      showLogModal: false,
      activeEditSection: 'Personal Information',
      activeLogSection: 'Personal Information',
      showInfoScreen: false,
      activeInfoScreen: '',
      showConfirmDelete: false,
      showConfirmEditClose: false,
      lastFocusedElement: null,
      isOverlay: false,
      overlayPlacement: 'bottom',
      saveChanges: false,
    }

    this.showEditModal = this.showEditModal.bind(this)
    this.hideEditModal = this.hideEditModal.bind(this)
    this.deleteSection = this.deleteSection.bind(this)
    this.addNewSection = this.addNewSection.bind(this)
    this.showLogModal = this.showLogModal.bind(this)
    this.hideLogModal = this.hideLogModal.bind(this)
    this.renderTextData = this.renderTextData.bind(this)
    this.showInfoModal = this.showInfoModal.bind(this)
    this.hideInfoModal = this.hideInfoModal.bind(this)
    this.showConfirmDeleteModal = this.showConfirmDeleteModal.bind(this)
    this.hideConfirmDeleteModal = this.hideConfirmDeleteModal.bind(this)
    this.showConfirmEditCloseModal = this.showConfirmEditCloseModal.bind(this)
    this.hideConfirmEditCloseModal = this.hideConfirmEditCloseModal.bind(this)
    this.handleIndexSelect = this.handleIndexSelect.bind(this)
    this.handleSaveChanges = this.handleSaveChanges.bind(this)
    this.syncSectionTextEditable = this.syncSectionTextEditable.bind(this)
    this.handleSaveChangesModal = this.handleSaveChangesModal.bind(this)
    this.changeSaveChangesState = this.changeSaveChangesState.bind(this)
    this.handleThreeDotsClickTracking =
      this.handleThreeDotsClickTracking.bind(this)
    this.handleDisabledLogBtnTracking =
      this.handleDisabledLogBtnTracking.bind(this)
    this.debounceTime = 2000
    this.sendTrackingDataDebounce = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )
    this.sendTrackingDataDebounceSave = _.debounce(sendTrackingData, 2000, true)
    this.sendTrackingDataDebounceAddSection = _.debounce(
      sendTrackingData,
      2000,
      true
    )
    this.sendTrackingDataDebounceDeleteSection = _.debounce(
      sendTrackingData,
      2000,
      true
    )
    this.sendTrackingDataDebounceStartWriting = _.debounce(
      sendTrackingData,
      2000,
      true
    )
    this.sendTrackingDataDebounceEditModal = _.debounce(
      sendTrackingData,
      1000,
      true
    )
    this.sendTrackingDataDebounceLogModal = _.debounce(
      sendTrackingData,
      1000,
      true
    )
    this.sendTrackingDataDebounceInfoModal = _.debounce(
      sendTrackingData,
      2000,
      true
    )
    this.sendTrackingDataDebounceThreeDotsBtn = _.debounce(
      sendTrackingData,
      this.debounceTime,
      true
    )

    this.elementId = []
    this.sectionWiseTextEditable = {}
  }

  replaceImageWithAvatarIfNotPresent(id) {
    $('#' + id).on('error', function () {
      $(this).attr(
        'src',
        `${process.env.APP_BASE_URL}dist/images/profile-avatar.png`
      )
      // $(this).attr('alt', 'profile picture not uploaded')
      $(this).attr(
        'alt',
        this.props.intl.formatMessage({
          id: "aspire.profileData.replaceImageWithAvatarIfNotPresent.profilePictureNotUploaded",
          defaultMessage: "Profile picture not uploaded"
        })
      )
    })
  }

  UNSAFE_componentWillUpdate() {
    this.replaceImageWithAvatarIfNotPresent('profile-data-img')
    this.replaceImageWithAvatarIfNotPresent('profile-data-img-1')
    let selectedPanel = this.props.selectedPanelPersonalInfo
    let id = '#' + selectedPanel
    $(id).unhighlight()
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      updateEditSection,
      editSectionUpdated,
      ui,
      section_wise_feedback,
      updateText,
      newSubSection,
      isUrlEditModal,
      showEditModal,
      isEditModal,
    } = this.props

    const { isOverlay, overlayPlacement } = this.state

    const { section, sectionWiseText } = ui
    this.props.underlineSpellError()
    $('.highlight').attr('tabindex', 11)
    $('.highlight').attr('role', 'menubar')
    $('.highlight-div').attr('tabindex', 11)
    $('.highlight-div').attr('role', 'menubar')
    if (this.props.currentSection == 'Personal Information') {
      let selectedPanel = this.props.selectedPanelPersonalInfo
      let id = '#' + selectedPanel
      if (!prevProps.isUrlEditModal && isUrlEditModal) {
        showEditModal(true, 'Personal Information')
        this.setState({
          showModal: true,
          activeEditSection: 'Personal Information',
        })
      }

      if (prevProps.isUrlEditModal && !isUrlEditModal) {
        showEditModal(false, '')
        this.setState({ showModal: false, activeEditSection: '' })
      }

      if (selectedPanel == 'connections') {
        let connections = null
        if (
          section_wise_feedback.hasOwnProperty(
            'personal_information_feedback'
          ) &&
          section_wise_feedback['personal_information_feedback'].hasOwnProperty(
            'connections_score_class'
          ) &&
          section_wise_feedback['personal_information_feedback'][
            'connections_score_class'
          ].hasOwnProperty('connections')
        ) {
          connections =
            section_wise_feedback['personal_information_feedback'][
              'connections_score_class'
            ]['connections']
        }

        if (!_.isNull(connections)) {
          $(id).highlight(connections.toString(), {
            wordsOnly: true,
            wordsBoundaryStart: '(?:[\\b\\W]|^)',
            wordsBoundaryEnd: '(?:[\\b\\W]|$)',
          })
          $(id)
            .find('span')
            .attr(
              'tabindex',
              tabIndexesSequence['personalInformation'][selectedPanel]
            )
        } else {
          $(id).highlight(sectionWiseText[selectedPanel])
          $(id)
            .find('span')
            .attr(
              'tabindex',
              tabIndexesSequence['personalInformation'][selectedPanel]
            )
          $(id).find('span').attr('role', 'menubar')
        }
      } else {
        $(id).highlight(sectionWiseText[selectedPanel])
        $(id)
          .find('span')
          .attr(
            'tabindex',
            tabIndexesSequence['personalInformation'][selectedPanel]
          )
        $(id).find('span').attr('role', 'menubar')
      }
    }

    let overlayHeight = cookie.get('accessible_styles') === 'true' ? 180 : 150

    if (isOverlay) {
      let height = document.documentElement.clientHeight
      let width = document.documentElement.clientWidth
      let overlayProp = $('#popover-contained').offset()
      if (
        overlayProp !== undefined &&
        height - overlayProp.top < overlayHeight &&
        overlayPlacement === 'bottom'
      ) {
        this.setState({ overlayPlacement: 'left' })
      } else if (
        overlayProp !== undefined &&
        height - overlayProp.top >= overlayHeight + 80 &&
        overlayPlacement === 'left'
      ) {
        this.setState({ overlayPlacement: 'bottom' })
      }
    }

    // if (updateEditSection === true && !_.isEmpty(sectionWiseText[sectionUnderscore[section]])) {
    //   this.props.changeNewSubSectionValue(false)
    // }

    if (isEditModal === true && updateEditSection === true) {
      editSectionUpdated()
    }

    if (isEditModal === true) {
      $('.div-overlay-opacity').addClass('as-unset-opacity')
      $('.div-over-overlay').addClass('as-unset-opacity')
    }

    if (prevProps.isEditModal === true && isEditModal === false) {
      $('.div-overlay-opacity').removeClass('as-unset-opacity')
      $('.div-over-overlay').removeClass('as-unset-opacity')
    }
  }

  setFocusOnActiveElement() {
    this.setState({ lastFocusedElement: document.activeElement })
  }

  getElementFocusedOnModalClose() {
    if (this.state.lastFocusedElement) {
      setTimeout(() => {
        this.state.lastFocusedElement.focus()
      }, 1)
    }
  }



  editButton(sectionName) {
    let logButton = null
    let editButton = null
    let logs = this.props.ui['logs']
    let currIndex = this.props.ui[sectionName]['currentIndex']
    let tabIndex = this.props.tabIndex
    let tourClassName = 'edit-sec-' + sectionName
    if (this.props.currentSection == sectionName) {
      editButton = (
        <div
          className={classNames('edit-sec ' + tourClassName)}
          role="button"
          tabIndex={tabIndex}
          onClick={() => this.showEditModal(sectionName)}>
          <FormattedMessage id="aspire.profileData.editButton.edit" defaultMessage="Edit" />
        </div>
      )
    } else {
      editButton = (
        <div
          className={classNames('edit-sec edit-sec-hide ' + tourClassName)}
          role="button"
          tabIndex={tabIndex}
          onClick={() => this.showEditModal(sectionName)}>
          <FormattedMessage id="aspire.profileData.editButton.edit" defaultMessage="Edit" />
        </div>
      )
    }

    return (
      <div className="edit-col z-index-9995 js-detailed-edit-log-buttons">
        {editButton}
      </div>
    )
  }

  editButton68(sectionName, tabIndex, key, subSectionIndex, len) {
    let editButton = null
    let currIndex = this.props.ui[sectionName]['currentIndex']
    if (this.props.currentSection == sectionName && currIndex == key) {
      editButton = (
        <div
          className={classNames(
            `edit-sec ${key == 0 ? 'edit-sec-first-' + sectionName : ''}`
          )}
          role="button"
          tabIndex={tabIndex}
          onClick={() => this.showEditModal(sectionName)}>
          <FormattedMessage id="aspire.profileData.editButton68.edit" defaultMessage="Edit" />
        </div>
      )
    } else {
      editButton = (
        <div
          className={classNames(
            `edit-sec edit-sec-hide ${
              key == 0 ? 'edit-sec-first-' + sectionName : ''
            }`
          )}
          role="button"
          tabIndex={tabIndex}
          data-key={sectionName}
          onClick={(e) => {
            this.handleIndexSelect(e, key, len, sectionName, subSectionIndex)
            this.showEditModal(sectionName)
          }}>
          <FormattedMessage id="aspire.profileData.editButton68.edit" defaultMessage="Edit" />
        </div>
      )
    }

    return (
      <div className="edit-col z-index-9995 js-detailed-edit-log-buttons">
        {editButton}
      </div>
    )
  }

  startWritingTracking() {
    let jsonObjectForTracking = {
      eventLabel: 'start_writing_btn',
      currentSection: this.props.currentSection,
    }
    this.sendTrackingDataDebounceStartWriting(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  addNewSection(sectionName = null) {
    let currentSection = this.props.currentSection
    if (!_.isNull(sectionName)) {
      currentSection = sectionName
    }
    let jsonObjectForTracking = {
      eventLabel: 'add_new_section_btn',
      currentSection: currentSection,
    }
    this.sendTrackingDataDebounceAddSection(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    if (this.props.savingChanges) {
      this.sendTrackingDataDebounce(
        'process',
        'aspire_detailed_feedback_screen',
        'notify_error',
        'cannot_process_until_current_complete'
      )
      notification(
        this.props.intl.formatMessage({
          id: "aspire.profileData.addNewSection.cannotProcess",
          defaultMessage: "Cannot process new data until current processing is complete."
        }),
        'error',
        timeOutMilliseconds
      )
      return
    }

    this.showEditModal(currentSection, true)
  }

  deleteSection() {
    const { fetchId, currentSection, processEditedData, savingChanges, intl } =
      this.props
    let currentIndex = this.props.ui[currentSection]['currentIndex']
    this.hideConfirmDeleteModal()

    let jsonObjectForTracking = {
      eventLabel: 'delete_section_btn',
      currentSection: currentSection,
      currentIndex: currentIndex,
    }

    this.sendTrackingDataDebounceDeleteSection(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    if (savingChanges) {
      this.sendTrackingDataDebounce(
        'process',
        'aspire_detailed_feedback_screen',
        'notify_error',
        'cannot_process_until_current_complete'
      )
      notification(
        this.props.intl.formatMessage({
          id: "aspire.profileData.deleteSection.cannotProcess",
          defaultMessage: "Cannot process new data until current processing is complete."
        }),
        'error',
        timeOutMilliseconds
      )
      return
    }

    let countSections = _.size(
      this.props.ui.sectionWiseTextStatic[sectionUnderscore[currentSection]]
    )
    let score =
      this.props.ui.sections[currentSection]['section_score'][currentIndex][
        'score'
      ]
    // Delete edit action to api
    processEditedData(
      fetchId,
      currentSection,
      currentIndex,
      countSections,
      false,
      {},
      '',
      {},
      score,
      true,
      false,
      intl
    )
  }

  getSectionWiseTextEditable(sectionName) {
    const { sectionWiseTextEditable } = this.props.ui
    let currSectionWiseTextEditable = deepCopy(sectionWiseTextEditable)

    if (sectionUnderscore[sectionName] in currSectionWiseTextEditable) {
      if (
        sectionName + '_new' in
        currSectionWiseTextEditable[sectionUnderscore[sectionName]]
      ) {
        return currSectionWiseTextEditable
      } else {
        let newSubsection = {}
        if (sectionName === 'Experience') {
          newSubsection = { company: '', from: '', text: '', title: '', to: '' }
        } else if (sectionName === 'Education') {
          newSubsection = {
            school: '',
            from: '',
            to: '',
            degree: '',
            field_of_study: '',
            grade: '',
            activities_and_societies: '',
          }
        } else {
          return currSectionWiseTextEditable
        }
        currSectionWiseTextEditable[sectionUnderscore[sectionName]][
          sectionName + '_new'
        ] = newSubsection
        return currSectionWiseTextEditable
      }
    }
  }

  showEditModal(sectionName, newSubSection = false) {
    if (this.props.savingChanges) {
      this.sendTrackingDataDebounce(
        'process',
        'aspire_detailed_feedback_screen',
        'notify_error',
        'cannot_process_until_current_complete'
      )
      notification(
        this.props.intl.formatMessage({
          id: "aspire.profileData.showEditModal.pleaseWait",
          defaultMessage: "Please wait for the processing to complete."
        }),
        'error',
        timeOutMilliseconds
      )
      return
    }

    this.props.changeNewSubSectionValue(newSubSection)
    const {
      editedSection,
      editedSubSectionId,
      editedSectionDeleted,
      changeModalState,
      ui,
      showEditModal,
      changeProfilePicInitialEditState,
    } = this.props

    if (this.props.currentSection !== sectionName) {
      if (
        sectionName === 'Profile Picture' ||
        sectionName === 'Personal Information'
      ) {
        this.props.onSelectSection('', 'profile_data', sectionName)
      } else {
        this.props.onSelectSection('', sectionName, sectionName)
      }
    }

    // editedSectionDeleted is true only during delete
    let currentIndex = this.props.ui[sectionName]['currentIndex']
    if (newSubSection == true) {
      currentIndex = sectionName + '_new'
    }

    if (
      !(
        editedSectionDeleted == true &&
        editedSection == sectionName &&
        currentIndex == editedSubSectionId
      )
    ) {
      this.setFocusOnActiveElement()
      if (sectionName === 'Personal Information') {
        this.props.showUrlEditModal(true)
      } else if (sectionName === 'Profile Picture') {
        changeProfilePicInitialEditState(1)
      }
      if (newSubSection) {
        let newSectionWiseTextEditable =
          this.getSectionWiseTextEditable(sectionName)
        this.props.updateText({
          updateKeys: [
            ['isEditOpen'],
            ['currentEditSection'],
            ['currentEditSectionIndex'],
            ['sectionWiseTextEditable'],
          ],
          data: {
            isEditOpen: true,
            currentEditSection: sectionName,
            currentEditSectionIndex: currentIndex,
            sectionWiseTextEditable: newSectionWiseTextEditable,
          },
        })
      } else {
        this.props.updateText({
          updateKeys: [
            ['isEditOpen'],
            ['currentEditSection'],
            ['currentEditSectionIndex'],
          ],
          data: {
            isEditOpen: true,
            currentEditSection: sectionName,
            currentEditSectionIndex: currentIndex,
          },
        })
      }
      showEditModal(true, sectionName)
      this.setState({ showModal: true, activeEditSection: sectionName })
      changeModalState('edit', true)

      let jsonObjectForTracking = {
        eventLabel: newSubSection ? 'new_sub_section' : 'edit_sub_section',
        sectionName: sectionName,
        subSectionId: newSubSection
          ? null
          : this.props.ui[sectionName]['currentIndex'],
      }

      this.sendTrackingDataDebounceEditModal(
        'event',
        'aspire_edit_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
      return
    }
  }

  syncSectionTextEditable(data) {
    this.sectionWiseTextEditable = data
  }

  handleSaveChangesModal() {
    this.setState(
      {
        saveChanges: true,
      },
      () => {
        this.setState({
          showConfirmEditClose: false,
        })
      }
    )
  }

  changeSaveChangesState(flag) {
    this.setState(
      {
        saveChanges: flag,
      },
      () => {}
    )
  }

  handleSaveChanges() {
    const { fetchId, newSubSection, processEditedData, intl } = this.props
    let sectionName = this.props.currentSection
    let currentIndex =
      this.props.newSubSection === true
        ? this.props.activeEditModalSection + '_new'
        : this.props.ui[sectionName]['currentIndex']
    let feedback = this.props.ui['sections'][sectionName]
    let sectionWiseTextStatic = this.props.ui.sectionWiseTextStatic
    let data =
      this.sectionWiseTextEditable[sectionUnderscore[sectionName]][currentIndex]

    let sectionUnderscoreName = sectionUnderscore[sectionName]

    let sectionEntities = []
    _.mapObject(charCountLimit, function (val, key) {
      if (key == sectionUnderscoreName) {
        sectionEntities = _.keys(val)
      }
    })

    if (sectionUnderscoreName === 'personal_information') {
      let entity = 'name'

      if (entity == 'name') {
        if (
          charCountLimit.hasOwnProperty(sectionUnderscoreName) &&
          charCountLimit[sectionUnderscoreName].hasOwnProperty(entity) &&
          charCountLimit[sectionUnderscoreName][entity] < data[entity].length
        ) {
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.maxNameLength",
              defaultMessage: "Maximum limit of {max} characters reached for Name field"
            }, { max: charCountLimit[sectionUnderscoreName][entity] }),
            'error',
            timeOutMilliseconds
          )
          return false
        }
        if (data[entity].length < 3) {
          // notification(errorMessage, 'error', timeOutMilliseconds)
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.minNameLength",
              defaultMessage: "Profile name should have at least 3 characters"
            }),
            'error',
            timeOutMilliseconds
          )
          return false
        }
      }

      entity = 'profile_url'

      if (entity == 'profile_url') {
        if (data[entity].length < 31) {
          // notification(errorMessage, 'error', timeOutMilliseconds)
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.minProfileUrlLength",
              defaultMessage: "Profile url should have at least 3 characters"
            }),
            'error',
            timeOutMilliseconds
          )
          return false
        }

        if (data[entity].length > 128) {
          //   'Maximum limit of 30 characters reached for Profile Url'
          // notification(errorMessage, 'error', timeOutMilliseconds)
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.maxProfileUrlLength",
              defaultMessage: "Maximum limit of 100 characters reached for Profile Url"
            }),
            'error',
            timeOutMilliseconds
          )
          return false
        }

        let testStr = data[entity]
        let param = testStr.slice(28)
        let valid = checkLinkedinUrlSanity(param)

        if (!valid) {
          // notification(errorMessage, 'error', timeOutMilliseconds)
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.invalidProfileUrl",
              defaultMessage: "There are some invalid characters in URL"
            }),
            'error',
            timeOutMilliseconds
          )
          return false
        }
      }
    } else if (
      sectionUnderscoreName == 'headline' ||
      sectionUnderscoreName == 'summary'
    ) {
      for (let i = 0; i < sectionEntities.length; i++) {
        let entity = sectionEntities[i]
        if (
          charCountLimit.hasOwnProperty(sectionUnderscoreName) &&
          charCountLimit[sectionUnderscoreName].hasOwnProperty(entity) &&
          charCountLimit[sectionUnderscoreName][entity] < data[entity].length
        ) {
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.maxSectionFieldLength",
              defaultMessage: "Maximum limit of {max} characters reached for {sectionName} field"
            }, { max: charCountLimit[sectionUnderscoreName][entity], sectionName }),
            'error',
            timeOutMilliseconds
          )
          return false
        }
      }
    } else if (
      sectionUnderscoreName == 'experience' ||
      sectionUnderscoreName == 'education'
    ) {
      for (let i = 0; i < sectionEntities.length; i++) {
        let entity = sectionEntities[i]
        let showField = entity
        if (entity == 'text') {
          showField = 'description'
        }
        if (
          charCountLimit.hasOwnProperty(sectionUnderscoreName) &&
          charCountLimit[sectionUnderscoreName].hasOwnProperty(entity) &&
          charCountLimit[sectionUnderscoreName][entity] < data[entity].length
        ) {
          notification(
            this.props.intl.formatMessage({
              id: "aspire.profileData.handleSaveChanges.maxFieldLength",
              defaultMessage: "Maximum limit of {max} characters reached for {field} field"
            }, { max: charCountLimit[sectionUnderscoreName][entity], field: showField }),
            'error',
            timeOutMilliseconds
          )
          return false
        }
      }
    }

    let prevData = {}
    if (newSubSection == false) {
      prevData =
        sectionWiseTextStatic[sectionUnderscore[sectionName]][currentIndex]
    }
    let countSections = _.size(
      sectionWiseTextStatic[sectionUnderscore[sectionName]]
    )
    let score = 0
    if (feedback['section_score'].hasOwnProperty(currentIndex)) {
      score = feedback['section_score'][currentIndex]['score']
    }

    if (sectionName == 'Profile Picture') {
      if (_.isObject(prevData['picture_string'])) {
        prevData['picture_string'] =
          prevData['picture_string']['profile_picture_string']
      }
      if (_.isObject(data['picture_string'])) {
        data['picture_string'] =
          data['picture_string']['profile_picture_string']
      }
    }

    let jsonObjectForTracking = {
      eventLabel: 'save_changes_btn',
      currentSection: sectionName,
      currentIndex: currentIndex,
    }
    this.sendTrackingDataDebounceSave(
      'event',
      'aspire_edit_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )

    let timeEditingEnd = new Date()
    let timeEditingSpent =
      (timeEditingEnd.getTime() - this.timeEditingStart) / 1000
    // this.timeEditingStart = timeEditingEnd.getTime()

    if (timeEditingSpent > 1) {
      let jsonObjectForTracking = {
        eventLabel: 'editing_time',
        time: timeEditingSpent,
      }
      this.sendTrackingDataDebounce(
        'event',
        'aspire_edit_screen',
        'time',
        JSON.stringify(jsonObjectForTracking)
      )
    }
    // Edit action to api
    processEditedData(
      fetchId,
      sectionName,
      currentIndex,
      countSections,
      newSubSection,
      data,
      '',
      prevData,
      score,
      false,
      this.emptyMessage(sectionName, data),
      intl
    )
  }

  emptyMessage(sectionName, data) {
    const sectionIdMap = {
      "Profile Picture": "aspire.logscreenNames.profilePicture",
      "Personal Information": "aspire.logscreenNames.personalInformation",
      "Headline": "aspire.logscreenNames.headline",
      "Summary": "aspire.logscreenNames.summary",
      "Experience": "aspire.logscreenNames.experience",
      "Education": "aspire.logscreenNames.education"
    };
    if (
      ['Summary', 'Headline'].includes(sectionName) &&
      _.isEmpty(data['text']) &&
      _.isEmpty(data['text'].trim())
    ) {
      const id = sectionIdMap[sectionName] || sectionName;
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.mustNotBeEmpty",
        defaultMessage: "{sectionName} field must not be empty."
      }, { sectionName: this.props.intl.formatMessage({ id: id, defaultMessage: sectionName }) })
    }

    if (
      sectionName == 'Experience' &&
      (_.isEmpty(data['title']) ||
        _.isEmpty(data['title'].trim()) ||
        _.isEmpty(data['company']) ||
        _.isEmpty(data['company'].trim()) ||
        _.isNull(data['from']) ||
        _.isNull(data['to']))
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.experienceRequired",
        defaultMessage: "Title, Company and Duration fields are compulsory for Experience section."
      })
    }

    if (sectionName == 'Experience') {
      let dateFormat = 'MMM YYYY'
      let fromDate = data['from']
      let tempFromDate = moment(fromDate, dateFormat, true)
      let fromCheck = tempFromDate.isValid()
      if (!fromCheck) {
        return this.props.intl.formatMessage({
          id: "aspire.profileData.emptyMessage.invalidFromDate",
          defaultMessage: "Invalid date format of 'From' field"
        })
      }

      if (!tempFromDate.isBefore(moment())) {
        return this.props.intl.formatMessage({
          id: "aspire.profileData.emptyMessage.startDatePast",
          defaultMessage: "Start date cannot be past today's date"
        })
      }
      data['from'] = tempFromDate.format(dateFormat)

      let toDate = data['to']
      let tempToDate = moment(toDate, dateFormat, true)
      if (toDate !== 'Present') {
        let toCheck = tempToDate.isValid()
        if (!toCheck) {
          return this.props.intl.formatMessage({
            id: "aspire.profileData.emptyMessage.invalidToDate",
            defaultMessage: "Invalid date format of 'To' field"
          })
        }

        if (!tempToDate.isBefore(moment())) {
          return this.props.intl.formatMessage({
            id: "aspire.profileData.emptyMessage.endDatePast",
            defaultMessage: "End date cannot be past today's date"
          })
        }

        if (
          !tempFromDate.isBefore(tempToDate, 'month') &&
          !tempFromDate.isSame(tempToDate, 'month')
        ) {
          return this.props.intl.formatMessage({
            id: "aspire.profileData.emptyMessage.endDateEarlier",
            defaultMessage: "End date cannot be earlier than Start date"
          })
        }
        data['to'] = tempToDate.format(dateFormat)
      }
    }

    if (
      sectionName == 'Education' &&
      _.isEmpty(data['school']) &&
      _.isEmpty(data['school'].trim())
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.educationSchoolRequired",
        defaultMessage: "School field is compulsory for Education section."
      })
    }

    if (
      sectionName == 'Education' &&
      _.isEmpty(data['from']) &&
      !_.isEmpty(data['to'])
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.educationFromRequired",
        defaultMessage: "From field is required."
      })
    }
    if (
      sectionName == 'Education' &&
      !_.isEmpty(data['from']) &&
      _.isEmpty(data['to'])
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.educationToRequired",
        defaultMessage: "To field is required."
      })
    }

    if (
      ['Volunteer Experience', 'Projects', 'Publications'].includes(
        sectionName
      ) &&
      _.isEmpty(data['title']) &&
      _.isEmpty(data['title'].trim())
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.titleRequired",
        defaultMessage: "Title field is compulsory in {sectionName} section."
      }, { sectionName })
    }

    if (
      sectionName == 'Personal Information' &&
      _.isEmpty(data['profile_url']) &&
      data['profile_url'].length < 33
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.invalidProfileUrl",
        defaultMessage: "Profile URL is invalid. Your custom URL may be outside range of 5-30 characters or uses characters that LinkedIn doesn’t allow."
      })
    }
    if (
      sectionName == 'Personal Information' &&
      _.isEmpty(data['name']) &&
      _.isEmpty(data['name'].trim())
    ) {
      return this.props.intl.formatMessage({
        id: "aspire.profileData.emptyMessage.profileNameRequired",
        defaultMessage: "Profile name must not be empty."
      })
    }

    return false
  }

  hideEditModal(
    currentSection,
    currentIndex,
    sectionWiseTextEditable,
    sectionWiseTextStatic,
    profilePictureConfirmClose = false
  ) {
    const { processingStatus } = this.props
    if (processingStatus == 'processing' || _.isNull(processingStatus)) {
      this.hideEditModalActual()
    } else if (currentSection == 'profile_picture') {
      if (profilePictureConfirmClose) {
        this.showConfirmEditCloseModal()
      } else {
        this.hideEditModalActual()
      }
    } else if (
      typeof currentIndex == 'string' &&
      currentIndex.indexOf('_new') >= 0
    ) {
      if (checkIfEmpty(sectionWiseTextEditable[currentIndex], currentSection)) {
        this.hideEditModalActual()
      } else {
        this.showConfirmEditCloseModal()
      }
    } else {
      if (
        JSON.stringify(sectionWiseTextEditable[currentIndex]) ===
        JSON.stringify(sectionWiseTextStatic[currentIndex])
      ) {
        this.hideEditModalActual()
      } else {
        this.showConfirmEditCloseModal()
      }
    }
    $('body').removeClass('modal-open')
  }

  hideEditModalActual() {
    const {
      changeModalState,
      editedSubSectionId,
      showUrlEditModal,
      showEditModal,
    } = this.props
    showUrlEditModal(false)
    showEditModal(false, '')
    this.setState({ showModal: false, activeEditSection: '' })
    this.props.changeNewSubSectionValue(false)
    this.getElementFocusedOnModalClose()
    changeModalState('edit', false)
    this.props.updateText({
      updateKeys: [
        ['isEditOpen'],
        ['currentEditSection'],
        ['currentEditSectionIndex'],
      ],
      data: {
        isEditOpen: false,
        currentEditSection: '',
        currentEditSectionIndex: '',
      },
    })
    this.hideConfirmEditCloseModal()
    $('body').removeClass('modal-open')
    $('#integrate-button').focus()
  }

  showConfirmEditCloseModal() {
    this.setState({ showConfirmEditClose: true })
  }

  hideConfirmEditCloseModal() {
    this.setState({ showConfirmEditClose: false })
    $('body').removeClass('modal-open')
  }

  showLogModal(sectionName) {
    const {
      editedSection,
      editedSubSectionId,
      editedSectionDeleted,
      changeModalState,
      showLogModal,
    } = this.props

    // editedSectionDeleted is true only during delete
    if (
      this.props.currentSection == sectionName &&
      !(
        editedSectionDeleted == true &&
        editedSection == sectionName &&
        this.props.ui[sectionName]['currentIndex'] == editedSubSectionId
      )
    ) {
      this.setFocusOnActiveElement()
      showLogModal(true)
      this.setState({ showLogModal: true, activeLogSection: sectionName })
      changeModalState('log', true)

      let jsonObjectForTracking = {
        eventLabel: 'log_modal_open',
        sectionName: sectionName,
        subSectionId: this.props.ui[sectionName]['currentIndex'],
      }

      this.sendTrackingDataDebounceLogModal(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
    }
  }
  handleDisabledLogBtnTracking(sectionName) {
    let jsonObjectForTracking = {
      eventLabel: 'disabled_log_btn_click',
      sectionName: sectionName,
      subSectionId: this.props.ui[sectionName]['currentIndex'],
    }

    this.sendTrackingDataDebounceLogModal(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }
  hideLogModal() {
    const {
      changeModalState,
      editedSectionDeleted,
      editedSubSectionId,
      showLogModal,
    } = this.props
    showLogModal(false)
    this.setState({ showLogModal: false, activeLogSection: '' })
    this.getElementFocusedOnModalClose()
    changeModalState('log', false)
  }


  showInfoModal(module) {
    this.sendTrackingDataDebounceInfoModal(
      'event',
      'aspire_info_screen_open',
      'click',
      module
    )
    this.setState({ showInfoScreen: true, activeInfoScreen: module })
  }

  hideInfoModal() {
    // sendTrackingData('event','aspire_info_screen_close','click',this.state.activeInfoScreen)
    this.setState({ showInfoScreen: false, activeInfoScreen: '' })
  }

  
  hideConfirmDeleteModal() {
    this.setState({ showConfirmDelete: false })
  }
  
  handleThreeDotsClickTracking() {
    this.sendTrackingDataDebounceThreeDotsBtn(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      'three_dots_btn'
    )
  }


  handleIndexSelect(e, newIndex, len, sectionName, currentIndex) {
    const { onSelectIndex, currentSection } = this.props
    if (currentSection !== sectionName) {
      this.props.onSelectSection(e, sectionName, sectionName)
      onSelectIndex(newIndex, len, sectionName, currentSection)
    } else if (newIndex == currentIndex) {
      this.showEditModal(sectionName)
    } else {
      onSelectIndex(newIndex, len, sectionName, currentSection)
    }
  }

  handleMouseOver(e) {
    let id = $(e.target).closest('[data-id]').data('id')
    $('#' + id).css({ color: '#000000' })
  }

  handleMouseOut(e) {
    let id = $(e.target).closest('[data-id]').data('id')
    $('#' + id).css({ color: '#828282' })
  }

  handleMouseOverDots(e) {
    let id = $(e.target).closest('[data-id]').data('id')
    $('#' + id).css({ 'background-color': 'gainsboro' })
  }

  handleMouseOutDots(e) {
    let id = $(e.target).closest('[data-id]').data('id')
    $('#' + id).css({ 'background-color': 'white' })
  }

  fetchImageUrl(url) {
    if (_.isEmpty(url)) {
      return `${process.env.APP_BASE_URL}dist/images/profile-avatar.png`
    }

    return url
  }

  showConfirmDeleteModal() {
    if (this.props.savingChanges) {
      this.sendTrackingDataDebounce(
        'process',
        'aspire_detailed_feedback_screen',
        'notify_error',
        'cannot_process_until_current_complete'
      )
      notification(
        this.props.intl.formatMessage({
          id: "aspire.profileData.showConfirmDeleteModal.cannotProcess",
          defaultMessage: "Cannot process new data until current processing is complete."
        }),
        'error',
        timeOutMilliseconds
      )
      return
    }

    this.setState({ showConfirmDelete: true })
  }


  renderSummary(summaryData, activeSummary, firstDivId, tabIndex) {
    let isShowOverlay =
      this.props.currentSection !== 'Summary' &&
      this.props.currentSection !== 'Overall'
    if (
      _.isEmpty(summaryData) ||
      (summaryData.hasOwnProperty('text') &&
        summaryData['text'].length == 1 &&
        summaryData['text'][0]['text'][0] == 'N/A')
    ) {
      return (
        <div
          className={classNames(
            'p-section p-section-empty-all',
            {
              'div-over-overlay': isShowOverlay,
            },
            {
              'div-overlay-opacity': isShowOverlay,
            },
            {
              'p-section-empty-select-all':
                this.props.currentSection === 'Summary',
            }
          )}
          data-key="Summary"
          role="button"
          tabIndex={tabIndex}
          onClick={(e) => {
            if (this.props.currentSection === 'Summary') {
              this.showEditModal('Summary', true)
            } else {
              this.props.onSelectSection(e, 'summary')
            }
          }}>
          <div className="p-section-name" id="summary" role="heading" aria-level="3">
            <FormattedMessage id="aspire.profileData.renderSummary.summaryHeading" defaultMessage="About" />
          </div>
          <div className="p-section-empty p-section-empty-Summary">
            <div>
              <div className="empty-section-btn">
                <a
                  className="btn btn-add"
                  href="javascript:void(0);"
                  tabIndex={tabIndex}
                  aria-label={this.props.intl.formatMessage({
                    id: "aspire.profileData.renderSummary.addSummaryAriaLabel",
                    defaultMessage: "You have not written this section, Click and start writing, + Add About"
                  })}
                  onClick={() => {
                    this.startWritingTracking()
                    this.showEditModal('Summary', true)
                  }}>
                  <FormattedMessage id="aspire.profileData.renderSummary.addSummaryBtn" defaultMessage="+ Add About" />
                </a>
                <div className="clearfix" />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      )
    }

    let data = (
      <div
        data-section="Summary"
        className={
          'profile contnet-left border-radius-top-none ' + activeSummary
        }
        data-key="Summary"
        onClick={(e) => {
          if (this.props.currentSection === 'Summary') {
            this.showEditModal('Summary')
          } else {
            this.props.onSelectSection(e, 'summary')
          }
        }}
        role="button"
        tabIndex={tabIndex}>
        <div>
          {this.renderTextData(
            summaryData['text'],
            'Summary',
            !_.isUndefined(firstDivId) && firstDivId.hasOwnProperty(0)
              ? firstDivId[0]
              : 10000
          )}
          {this.editButton('Summary')}
        </div>
        <div className="clearfix" />
      </div>
    )

    return (
      <div
        className={classNames(
          'p-section p-section-summary',
          {
            'div-over-overlay': isShowOverlay,
          },
          {
            'div-overlay-opacity': isShowOverlay,
          },
          {
            'p-section-select-all': this.props.currentSection === 'Summary',
          }
        )}
        data-key="Summary">
        <div
          className="p-section-name"
          data-key="Summary"
          role="button"
          tabIndex={tabIndex}
          onClick={(e) => {
            this.props.onSelectSection(e, 'summary')
          }}
          id="summary"
        >
          <FormattedMessage id="aspire.profileData.renderSummary.summaryHeading" defaultMessage="About" />
        </div>
        <div
          className={classNames({
            'p-section-select': this.props.currentSection === 'Summary',
          })}>
          {data}
        </div>
      </div>
    )
  }

  render68(experienceData, sectionName, firstDivId, tabIndex) {
    let isShowOverlay =
      this.props.currentSection !== sectionName &&
      this.props.currentSection !== 'Overall'
    let len = _.size(experienceData)
    let index = this.props.ui[sectionName]['currentIndex']
    const sectionNameToIntlId = {
      "Profile Picture": "aspire.logscreenNames.profilePicture",
      "Personal Information": "aspire.logscreenNames.personalInformation",
      "Headline": "aspire.logscreenNames.headline",
      "Summary": "aspire.logscreenNames.summary",
      "Experience": "aspire.logscreenNames.experience",
      "Education": "aspire.logscreenNames.education"
    };
    const {intl} = this.props;
    const sectionId = sectionNameToIntlId[sectionName] || sectionName;

    if (_.isEmpty(experienceData)) {
      return (
        <div
          id={sectionUnderscore[sectionName]}
          data-section={sectionName}
          className={classNames(
            'p-section p-section-empty-all',
            {
              'div-over-overlay': isShowOverlay,
            },
            {
              'div-overlay-opacity': isShowOverlay,
            },
            {
              'p-section-empty-select-all':
                this.props.currentSection === sectionName,
            },
            {
              'p-section-education': sectionName === 'Education',
            }
          )}
          data-key={sectionName}
          role="button"
          tabIndex={tabIndex}
          onClick={(e) => {
            if (this.props.currentSection === sectionName) {
              this.showEditModal(sectionName, true)
            } else {
              this.props.onSelectSection(e, sectionName.toLowerCase())
            }
          }}>
          <div className="p-section-name" id={sectionUnderscore[sectionName]} role="heading" aria-level="3">
            <FormattedMessage id={sectionId} defaultMessage={sectionName} />
          </div>
          <div className={`p-section-empty p-section-empty-${sectionName}`}>
            <div>
              <div className="empty-section-btn">
                <a
                  className="btn btn-add"
                  href="javascript:void(0);"
                  tabIndex={tabIndex}
                  aria-label={this.props.intl.formatMessage({
                    id: "aspire.profileData.render68.addSectionAriaLabel",
                    defaultMessage: "You have not written this section, Click and start writing, + Add {sectionName}"
                  }, { sectionName: intl.formatMessage({ id: sectionId }) })}
                  onClick={() => {
                    this.startWritingTracking()
                    this.showEditModal(sectionName, true)
                  }}>
                  <FormattedMessage id="aspire.profileData.render68.addSectionBtn" defaultMessage="+ Add {sectionName}" values={{ sectionName: intl.formatMessage({ id: sectionId }) }} />
                </a>
                <div className="clearfix" />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      )
    }

    let threeDotsBtn = (
      <Dropdown
        id={`three-dots-dropdown-${sectionName}`}
        className="three-dots-dropdown"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}>
        <Dropdown.Toggle
          tabIndex={tabIndex}
          noCaret
          className="three-dots-toggle-btn text-btn">
          <img
            src={`${process.env.APP_BASE_URL}dist/images/appbar-three-dots.svg`}
            alt={this.props.intl.formatMessage({
              id: "aspire.profileData.render68.menuBtnAlt",
              defaultMessage: "menu btn"
            })}
            width="25px"
            height="25px"
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="three-dots-menu">
          <Dropdown.Item
            className="three-dots-menu-item"
            onSelect={this.showConfirmDeleteModal}
            onClick={() => this.showConfirmDeleteModal()}
            eventKey="1">
            <img
              className="delete-menu-icon"
              src={`${process.env.APP_BASE_URL}dist/images/icon-delete.svg`}
              alt={this.props.intl.formatMessage({
                id: "aspire.profileData.render68.deleteIconAlt",
                defaultMessage: "Delete icon"
              })}
            />
            <FormattedMessage
              id="aspire.profileData.render68.deleteMenuText"
              defaultMessage="Delete this {sectionType, select, Education {education} other {position}}"
              values={{
                sectionType: sectionName
              }}
            />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )

    firstDivId =
      !_.isUndefined(firstDivId) && firstDivId.hasOwnProperty(index)
        ? firstDivId[index]
        : 10000

    let data = _.map(
      experienceData,
      function (experience, key) {
        let isCorrectIndex =
          this.props.currentSection === sectionName && key == index
        let overlayCondition =
          isCorrectIndex || this.props.currentSection === 'Overall'
        return (
          <div
            id={sectionUnderscore[sectionName] + key}
            data-section={sectionName}
            className={classNames(
              `profile contnet-left p-sub-section p-sub-section-${sectionName} ${
                key == 0 ? 'p-sub-section-' + sectionName + '-first' : ''
              }`,
              {
                'active-sub-section': isCorrectIndex,
              },
              {
                'p-sub-section-select': isCorrectIndex,
              },
              {
                'div-over-overlay': !overlayCondition,
              },
              {
                'div-overlay-opacity': !overlayCondition,
              },
              {
                'div-overlay-sub-section': !overlayCondition,
              },
              {
                'p-sub-section-education-last':
                  sectionName === 'Education' && key == parseInt(len) - 1,
              }
            )}
            data-key={sectionName}
            onClick={(e) => {
              this.handleIndexSelect(e, key, len, sectionName, index)
            }}
            role="button"
            tabIndex={tabIndex}>
            {this.editButton68(sectionName, tabIndex, key, index, len)}
            {this.props.currentSection === sectionName &&
              key == index &&
              threeDotsBtn}
            {this.renderTextData(experience['title'], sectionName, firstDivId)}
            {this.renderTextData(
              experience['sub_title'],
              sectionName,
              firstDivId
            )}
            {this.renderTextData(
              experience['time_duration'],
              sectionName,
              firstDivId
            )}
            <div>
              {this.renderTextData(experience['text'], sectionName, firstDivId)}
            </div>
            <div className="clearfix" />
          </div>
        )
      },
      this
    )

    return (
      <div
        className={classNames(
          'p-section',
          {
            'p-section-select-all': this.props.currentSection === sectionName,
          },
          {
            'p-section-education': sectionName === 'Education',
          },
          {
            'p-section-experience': sectionName === 'Experience',
          }
        )}>
        <div
          className={classNames(
            'p-section-name',
            {
              'div-over-overlay': isShowOverlay,
            },
            {
              'div-overlay-opacity': isShowOverlay,
            }
          )}
          data-key={sectionName}
          onClick={(e) => {
            this.props.onSelectSection(e, sectionName)
          }}
          id={sectionUnderscore[sectionName]}
          role="button"
          tabIndex={tabIndex}>
          <FormattedMessage id={sectionId} defaultMessage={sectionName} />
          <div
            className="add-sec-btn-div tooltipped tooltipped-s"
            role="button"
            data-tooltip={this.props.intl.formatMessage({
              id: "aspire.profileData.render68.addBtnTooltip",
              defaultMessage: "Add new {sectionType, select, Education {education} other {position}}"
            }, { sectionType: sectionName })}
            aria-label={this.props.intl.formatMessage({
              id: "aspire.profileData.render68.addBtnAriaLabel",
              defaultMessage: "Add new {sectionType, select, Education {education} other {position}}"
            }, { sectionType: sectionName })}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              this.addNewSection(sectionName)
            }}
            tabIndex={tabIndex}>
            <FormattedMessage id="aspire.profileData.render68.addBtn" defaultMessage="+ Add" />
          </div>
        </div>
        <div
          className={classNames(
            {
              'p-all-section-select':
                this.props.currentSection === sectionName && _.isNull(index),
            },
            {
              'p-all-section-select-education':
                this.props.currentSection === sectionName &&
                this.props.currentSection === 'Education' &&
                _.isNull(index),
            }
          )}
          data-key={sectionName}>
          {data}
        </div>
      </div>
    )
  }

  renderSkills(skillsData) {
    if (_.isEmpty(skillsData)) {
      if (this.props.currentSection == 'Skills') {
        return (
          <div>
            <div className="profile active-section border-radius-top-none">
              <p className="p-heading-3">
                <FormattedMessage id="aspire.profileData.renderSkills.emptySection" defaultMessage="You have not written this section" />
              </p>
              <a className="btn2 btn btn-primary" href="javascript:void(0);">
                <FormattedMessage id="aspire.profileData.renderSkills.startWritingBtn" defaultMessage="Start writing" />{' '}
                <span className="glyphicon glyphicon glyphicon-pencil" />{' '}
              </a>
              <div className="clearfix" />
              <br />
              <br />
            </div>
          </div>
        )
      } else {
        return []
      }
    }

    let data = (
      <div
        id="Skills"
        className={classNames('profile', {
          'active-section': this.props.currentSection === 'Skills',
        })}>
        <p className="p-heading-1 align-text-left">
          <FormattedMessage id="aspire.profileData.renderSkills.topSkills" defaultMessage="Top Skills" />
        </p>
        <ul className="skills-keywords keywords-gray keyqords-r-paiding-none tab-r-paiding-none">
          {skillsData}
        </ul>
        {this.editButton('Skills')}
      </div>
    )

    if (this.props.currentSection == 'Skills') {
      return (
        <div
          className="div-over-overlay div-overlay-opacity"
          onClick={(e) => this.props.onSelectSection(e, 'profile_data')}
          data-key="Skills">
          {data}
        </div>
      )
    } else {
      return data
    }
  }


  renderImage(active, sectionWiseText, tabIndex) {
    let imageUrl = this.fetchImageUrl(sectionWiseText['imageUrl']).includes(
      'avatardefault'
    )
      ? process.env.APP_BASE_URL + 'dist/images/person-avatar.svg'
      : this.fetchImageUrl(sectionWiseText['imageUrl'])
    let isShowOverlay =
      this.props.currentSection !== 'Profile Picture' &&
      this.props.currentSection !== 'Overall';
    let data = (
      <div
        key={`${sectionWiseText['name']}-inactive`}
        className={'profile profile-img ' + active['profilePicture']}>
        <div
          className={classNames('edit-sec edit-sec-img', {
            'edit-sec-hide': this.props.currentSection !== 'Profile Picture',
          })}
          role="button"
          tabIndex="0"
          onClick={() => this.showEditModal('Profile Picture')}>
          <FormattedMessage id="aspire.profileData.renderImage.edit" defaultMessage="Edit" />
        </div>
        <img
          src={imageUrl}
          id="profile-data-img"
          width="140px"
          height="140px"
          className="rounded-circle p-image"
          alt=""
        />
        <div className="clearfix" />
      </div>
    )

    return (
      <div
        className={classNames(
          'p-section p-section-img',
          {
            'div-over-overlay': isShowOverlay,
          },
          {
            opacity29: isShowOverlay,
          },
          {
            'p-section-select': this.props.currentSection === 'Profile Picture',
          }
        )}
        onClick={(e) => {
          if (this.props.currentSection === 'Profile Picture') {
            this.showEditModal('Profile Picture')
          } else {
            this.props.onSelectSection(e, 'profile_data')
          }
        }}
        id="profile_picture_linkedin"
        data-key="Profile Picture"
        role="button"
        tabIndex={tabIndex}>
        {data}
      </div>
    )
  }

  renderName(active, sectionWiseText, tabIndex) {
    let isShowOverlay =
      this.props.currentSection !== 'Personal Information' &&
      this.props.currentSection !== 'Overall'
    let data = (
      <>
        <div
          key={`${sectionWiseText['name']}-inactive`}
          className={
            'profile border-radius-padding-none profile-name-zindex ' +
            active['personalInformation']
          }>
          <div className="p-name" id="name">
            {sectionWiseText['name']}
            <div
              className={classNames('edit-sec edit-sec-name', {
                'edit-sec-hide':
                  this.props.currentSection !== 'Personal Information',
              })}
              role="button"
              tabIndex={tabIndex}
              onClick={() => this.showEditModal('Personal Information')}
              data-key="Personal Information">
              <FormattedMessage id="aspire.profileData.renderName.edit" defaultMessage="Edit" />
            </div>
          </div>
          <div className="clearfix" />
        </div>
        <div
          className={
            'profile border-radius-padding-none ' +
            active['personalInformation']
          }>
          <div className="padding-bottom-10">
            <span id="profile_url">{sectionWiseText['profile_url']}</span>
          </div>
          <div className="clearfix" />
        </div>
      </>
    )

    return (
      <div
        key={`${sectionWiseText['name']}-active`}
        className={classNames(
          'p-section p-section-pi',
          {
            'p-section-select':
              this.props.currentSection === 'Personal Information',
          },
          { 'div-over-overlay': isShowOverlay },
          { opacity29: isShowOverlay }
        )}
        onClick={(e) => {
          if (this.props.currentSection === 'Personal Information') {
            this.showEditModal('Personal Information')
          } else {
            this.props.onSelectSection(e, 'profile_data')
          }
        }}
        id="personal_information"
        data-key="Personal Information"
        role="button"
        tabIndex={tabIndex}>
        {data}
      </div>
    )
  }

  renderHeadline(active, sectionWiseText, editHeadline, firstDivId, tabIndex) {
    let isShowOverlay =
      this.props.currentSection !== 'Headline' &&
      this.props.currentSection !== 'Overall'
    let data = (
      <div
        data-section="Headline"
        className={
          'feedback-headline-padding profile border-radius-padding-none ' +
          active['headline'] +
          ' ' +
          active['personalInfoHeadline']
        }>
        <div className="p-headline">
          {this.renderTextData(
            sectionWiseText['headline'],
            'Headline',
            !_.isUndefined(firstDivId) && firstDivId.hasOwnProperty(0)
              ? firstDivId[0]
              : 10000
          )}
        </div>
        <div
          className={classNames('edit-sec edit-sec-headline', {
            'edit-sec-hide': this.props.currentSection !== 'Headline',
          })}
          role="button"
          tabIndex={tabIndex}
          data-key="Headline"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            if (this.props.currentSection === 'Headline') {
              this.showEditModal('Headline')
            } else {
              this.props.onSelectSection(e, 'Headline')
            }
          }}>
          <FormattedMessage id="aspire.profileData.renderHeadline.edit" defaultMessage="Edit" />
        </div>
        <div className="clearfix" />
      </div>
    )

    return (
      <div
        className={classNames(
          'p-section p-section-headline',
          { 'p-section-select': this.props.currentSection === 'Headline' },
          { 'div-over-overlay': isShowOverlay },
          { opacity29: isShowOverlay }
        )}
        onClick={(e) => {
          if (this.props.currentSection === 'Headline') {
            this.showEditModal('Headline')
          } else {
            this.props.onSelectSection(e, 'Headline')
          }
        }}
        id="headline"
        data-key="Headline"
        role="button"
        tabIndex={tabIndex}>
        {data}
      </div>
    )
  }

  overlayToggle() {
    this.setState({ isOverlay: true })
  }

  overlayExit() {
    this.setState({ isOverlay: false })
  }

  localizeLogDateString(text, intl) {
    const monthMap = {
      Jan: intl.formatMessage({ id: 'aspire.months.jan', defaultMessage: 'Jan' }),
      Feb: intl.formatMessage({ id: 'aspire.months.feb', defaultMessage: 'Feb' }),
      Mar: intl.formatMessage({ id: 'aspire.months.mar', defaultMessage: 'Mar' }),
      Apr: intl.formatMessage({ id: 'aspire.months.apr', defaultMessage: 'Apr' }),
      May: intl.formatMessage({ id: 'aspire.months.may', defaultMessage: 'May' }),
      Jun: intl.formatMessage({ id: 'aspire.months.jun', defaultMessage: 'Jun' }),
      Jul: intl.formatMessage({ id: 'aspire.months.jul', defaultMessage: 'Jul' }),
      Aug: intl.formatMessage({ id: 'aspire.months.aug', defaultMessage: 'Aug' }),
      Sep: intl.formatMessage({ id: 'aspire.months.sep', defaultMessage: 'Sep' }),
      Oct: intl.formatMessage({ id: 'aspire.months.oct', defaultMessage: 'Oct' }),
      Nov: intl.formatMessage({ id: 'aspire.months.nov', defaultMessage: 'Nov' }),
      Dec: intl.formatMessage({ id: 'aspire.months.dec', defaultMessage: 'Dec' }),
    };

    const monthRegex = /\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/g;
    if (monthRegex.test(text)) {
      let localized = text.replace(monthRegex, (match) => monthMap[match] || match);
      localized = localized.replace(/\bPresent\b/gi, intl.formatMessage({ id: 'aspire.logscreen.present', defaultMessage: 'Present' }));
      return localized;
    }
    return text;
  }

  renderTextData(textData, sectionName, firstDivId, arrayIndex = null) {
    if (_.isString(textData) || _.isNull(textData)) {
      const dateRangeRegex = /^\s*(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{4}\s*[-–]\s*((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{4}|Present)\s*$/;
      if (dateRangeRegex.test(textData)) {
        return this.localizeLogDateString(textData, this.props.intl);
      }
      return textData
    }

    if (_.isArray(textData)) {
      var output = []

      for (let i in textData) {
        output.push(
          this.renderTextData(textData[i], sectionName, firstDivId, i)
        )
      }

      return output
    }

    if (_.isObject(textData)) {
      var output = []
      let tempOutput = null

      if (
        arrayIndex !== '0' &&
        textData.hasOwnProperty('new_line') &&
        textData['new_line'] == true
      ) {
        output.push(<br />)
      } else if (
        arrayIndex !== '0' &&
        textData.hasOwnProperty('new_paragraph') &&
        textData['new_paragraph'] == true
      ) {
        output.push(<br />)
      }
      let id = Math.floor(Math.random() * 10000 + 1)
      if (textData.hasOwnProperty('div_id') && !_.isEmpty(textData['div_id'])) {
        let divId = parseInt(textData['div_id'])
        if (divId >= firstDivId + 20) {
          divId = Math.ceil((divId - firstDivId) / 20) * 20 + firstDivId
          id = 'profile-data-' + divId
        }
      }

      let key = this.generateRandomString()

      if (textData['type'] == 'div') {
        tempOutput = (
          <div
            id={id}
            key={key}
            target={'target-' + key}
            className={this.getClass(textData)}>
            {textData.hasOwnProperty('bullet') ? textData['bullet'] : null}
            {this.renderTextData(textData['text'], sectionName, firstDivId)}
          </div>
        )
      } else if (textData['type'] == 'span') {
        tempOutput = (
          <span
            id={id}
            key={key}
            target={'target-' + key}
            className={this.getClass(textData)}>
            {textData.hasOwnProperty('bullet') ? textData['bullet'] : null}
            {this.renderTextData(textData['text'], sectionName, firstDivId)}
            {textData.hasOwnProperty('end_period') &&
            textData['end_period'] === true
              ? ' '
              : ''}
          </span>
        )
      } else if (textData['type'] == 'title_span') {
        tempOutput = (
          <div id={id} className="p-heading-1">
            <span
              key={key}
              target={'target-' + key}
              className={this.getClass(textData)}>
              {textData.hasOwnProperty('bullet') ? textData['bullet'] : null}
              {this.renderTextData(textData['text'], sectionName, firstDivId)}
            </span>
          </div>
        )
      } else if (textData['type'] == 'input') {
        if (textData.hasOwnProperty('name')) {
          tempOutput = (
            <input
              id={id}
              name={textData['name']}
              className={this.getClass(textData)}
              value={this.inputValue(textData)}
            />
          )
        } else {
          tempOutput = (
            <input
              id={id}
              className={this.getClass(textData)}
              value={this.inputValue(textData)}
            />
          )
        }
      }

      if (
        textData.hasOwnProperty('suggestions') &&
        !_.isEmpty(textData['suggestions'])
      ) {
        var popoverOverlay = (
          <Popover
            id={'popover-contained-gray'}
            aria-label="popover"
            className="feedback-word-popover">
            <strong>
              <FormattedMessage
                id="aspire.profileData.renderTextData.suggestions"
                defaultMessage="Use words like {suggestions} for higher quality of language."
                values={{ suggestions: textData['suggestions'].join(', ') }}
              />
            </strong>
          </Popover>
        )

        if (textData['module_type'] == 'action_oriented') {
          var popoverOverlay = (
            <Popover
              id={'popover-contained-gray'}
              aria-label="popover"
              className="feedback-word-popover">
              <strong>
                <FormattedMessage
                  id="aspire.profileData.renderTextData.weakVerb"
                  defaultMessage="{text} is considered to be a weak verb. Although in some cases it may make sense to do so, try to re-word your sentence to start with stronger action verbs. Some common ones used by your peers are: {suggestions}"
                  values={{
                    text: textData['text'],
                    suggestions: textData['suggestions'].join(', '),
                  }}
                />
              </strong>
            </Popover>
          )
        } else if (textData['module_type'] == 'verb_overusage') {
          var popoverOverlay = (
            <Popover
              id={'popover-contained-gray'}
              aria-label="popover"
              className="feedback-word-popover">
              <strong>
                <FormattedMessage
                  id="aspire.profileData.renderTextData.verbOverusage"
                  defaultMessage="You have written {text} multiple times in this section. Consider re-phrasing it with usages such as: {suggestions}"
                  values={{
                    text: textData['text'],
                    suggestions: textData['suggestions'].join(', '),
                  }}
                />
              </strong>
            </Popover>
          )
        }
        output.push(
          <OverlayTrigger
            trigger={['focus', 'hover']}
            rootClose
            placement="top"
            overlay={popoverOverlay}
            container={this}
            onEnter={() => this.overlayToggle()}
            onExit={() => this.overlayExit()}>
            {tempOutput}
          </OverlayTrigger>
        )
      } else {
        output.push(tempOutput)
      }
    }
    return output
  }

  getClass(textData) {
    if (textData.hasOwnProperty('class')) {
      return (
        textData['class']['highlight_class'] + ' ' + textData['class']['others']
      )
    }

    return null
  }

  generateRandomString(length = 10) {
    let text = ''
    let possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }

    return text
  }

  inputValue(textData) {
    if (_.isNull(textData)) {
      return ''
    }

    if (_.isString(textData)) {
      return textData
    }

    let output = []

    if (_.isArray(textData)) {
      for (let i in textData) {
        output.push(this.inputValue(textData[i]))
      }
    }

    if (_.isObject(textData)) {
      let bullet =
        textData.hasOwnProperty('bullet') + ' ' ? textData['bullet'] : ''
      output.push(bullet)
      output.push(this.inputValue(textData['text']))
    }

    return output.join('')
  }


  render() {
    const {
      fetchId,
      totalScore,
      totalScoreColor,
      currentSection,
      sectionWiseText,
      sectionWiseTextPdf,
      resumeSkillsInLinkedin,
      ui,
      updateEditSection,
      editSectionUpdated,
      processingStatus,
      changeNewSubSectionValue,
      tabIndex,
      isEditModal,
    } = this.props

    let currentTab = tabIndex

    let active = {
      profilePicture: '',
      personalInformation: '',
      personalInfoHeadline: '',
      headline: '',
      summary: '',
    }

    let editHeadline = true

    if (currentSection === 'Personal Information') {
      active['personalInformation'] = 'active-section'
      active['personalInfoHeadline'] = 'active-section'
      editHeadline = false
    } else if (currentSection === 'Profile Picture') {
      active['profilePicture'] = 'active-section'
    } else if (currentSection === 'Headline') {
      active['headline'] = 'active-section'
    } else if (currentSection === 'Summary') {
      active['summary'] = 'active-section'
    }

    let bottomPadding = '450px'

    if (window.innerHeight > 1000) {
      bottomPadding = '200px'
    }

    let editComponent = []

    if (isEditModal === true && currentSection !== 'Overall') {
      var currIndex =
        this.props.newSubSection === true
          ? this.props.activeEditModalSection + '_new'
          : this.props.ui[this.props.activeEditModalSection]['currentIndex']
      editComponent.push(
        <EditScreens
          focusDisable={this.state.showConfirmEditClose}
          show={isEditModal}
          fetchId={fetchId}
          sectionName={this.props.activeEditModalSection}
          newSubSection={this.props.newSubSection}
          currentIndex={currIndex}
          derivedSkills={this.props.ui.derivedSkills}
          sectionWiseText={sectionWiseText}
          sectionsEntitiesToHighlight={
            this.props.ui.sectionsEntitiesToHighlight
          }
          sectionsPerSkill={this.props.ui['sectionsPerSkill']}
          resumeSkillsInLinkedin={resumeSkillsInLinkedin}
          feedback={this.props.ui['sections'][currentSection]}
          showEditModal={this.showEditModal}
          hideEditModal={this.hideEditModal}
          showConfirmDeleteModal={this.showConfirmDeleteModal}
          showLogModal={this.showLogModal}
          deleteSection={this.deleteSection}
          addNewSection={this.addNewSection}
          updateEditSection={updateEditSection}
          editSectionUpdated={editSectionUpdated}
          changeNewSubSectionValue={changeNewSubSectionValue}
          handleSaveChanges={this.handleSaveChanges}
          syncSectionTextEditable={this.syncSectionTextEditable}
          saveChanges={this.state.saveChanges}
          changeSaveChangesState={this.changeSaveChangesState}
          highlightableEditDivWords={this.props.highlightableEditDivWords}
        />
      )
    }

    let logComponent = []

    if (this.state.showLogModal === true) {
      let logs = this.props.ui['logs']
      var currIndex = this.props.ui[currentSection]['currentIndex']
      let countSections = _.size(
        this.props.ui.sectionWiseTextStatic[sectionUnderscore[currentSection]]
      )
      let prevData =
        this.props.ui.sectionWiseTextStatic[sectionUnderscore[currentSection]][
          currIndex
        ]

      logComponent.push(
        <LogScreen
          show={this.props.show_log_modal}
          fetchId={fetchId}
          sectionName={currentSection}
          logs={logs}
          feedback={this.props.ui['sections']}
          prevData={this.props.ui.sectionWiseTextStatic}
          showLogModal={this.showLogModal}
          hideLogModal={this.hideLogModal}
        />
      )
    }

    let infoComponent = null

    if (this.state.showInfoScreen == true) {
      infoComponent = (
        <InfoScreens
          show={this.state.showInfoScreen}
          module={this.state.activeInfoScreen}
          currentSection={currentSection}
          hideModal={this.hideInfoModal}
        />
      )
    }

    return (
      <div className="profile-outer-div">
        {editComponent}
        {logComponent}
        {infoComponent}
        <PdfData sectionWiseTextPdf={sectionWiseTextPdf} />
        {(!(isEditModal && currentSection !== 'Overall') ||
          (isEditModal && currentSection === 'Profile Picture')) && (
          <div className="profile-sec tour-scroll js-detailed-tall scrollbar-elements">
            <div className="profile-container" id="Overall">
              {this.renderImage(active, sectionWiseText, tabIndex)}
              {this.renderName(active, sectionWiseText, tabIndex)}
              {this.renderHeadline(
                active,
                sectionWiseText,
                editHeadline,
                ui['sections']['Headline']['first_div_id'],
                tabIndex
              )}
              {this.renderSummary(
                sectionWiseText['summary'],
                active['summary'],
                ui['sections']['Summary']['first_div_id'],
                tabIndex
              )}
              {this.render68(
                sectionWiseText['experience'],
                'Experience',
                ui['sections']['Experience']['first_div_id'],
                tabIndex
              )}
              {this.render68(
                sectionWiseText['education'],
                'Education',
                ui['sections']['Education']['first_div_id'],
                tabIndex
              )}
            </div>
          </div>
        )}
        <FocusLock disabled={!this.state.showConfirmDelete}>
          <Modal
            isOpen={this.state.showConfirmDelete}
            onRequestHide={this.hideConfirmDeleteModal}
            keyboard={true}>
            <div className="delete-modal">
              <div className="card-block-lg text-center">
                <div className="delete-modal-icon-row">
                  <div className="delete-modal-icon-wrapper">
                    <img
                      className="delete-modal-icon"
                      src={`${process.env.APP_BASE_URL}dist/images/ic_delete_alert.svg`}
                      alt={this.props.intl.formatMessage({
                        id: "aspire.profileData.renderConfirmDelete.deleteIconAlt",
                        defaultMessage: "Delete icon"
                      })}
                    />
                  </div>
                </div>
                <div className="delete-modal-heading">
                  <FormattedMessage
                    id="aspire.profileData.renderConfirmDelete.heading"
                    defaultMessage="Confirm {sectionType, select, Education {Education} other {Position}} Delete"
                    values={{
                      sectionType: currentSection
                    }}
                  />
                </div>
                <div className="delete-modal-subheading">
                  <FormattedMessage
                    id="aspire.profileData.renderConfirmDelete.subheading"
                    defaultMessage="Are you sure you want to delete this {sectionType, select, Education {education} other {position}}?"
                    values={{
                      sectionType: currentSection
                    }}
                  />
                </div>
                <div className="delete-modal-btn-grp">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-no"
                    aria-label={this.props.intl.formatMessage({
                      id: "aspire.profileData.renderConfirmDelete.cancelBtn",
                      defaultMessage: "Click to exit the delete modal"
                    })}
                    onClick={this.hideConfirmDeleteModal}>
                    <FormattedMessage
                      id="aspire.profileData.renderConfirmDelete.cancelBtn"
                      defaultMessage="Cancel"
                    />
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-yes"
                    aria-label={this.props.intl.formatMessage({
                      id: "aspire.profileData.renderConfirmDelete.deleteBtn",
                      defaultMessage: "Click to delete the section"
                    })}
                    onClick={() => this.deleteSection()}>
                    <FormattedMessage
                      id="aspire.profileData.renderConfirmDelete.deleteBtn"
                      defaultMessage="Delete"
                    />
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </FocusLock>
        <FocusLock disabled={!this.state.showConfirmEditClose}>
          <Modal
            isOpen={this.state.showConfirmEditClose}
            onRequestHide={this.hideConfirmEditCloseModal}
            keyboard={true}>
            <div className="as-confirm-edit-close delete-modal as-confirm-edit-close-backdrop">
              <div className="delete-modal-close-icon">
                <a
                  href="javascript:void(0);"
                  aria-label={this.props.intl.formatMessage({
                    id: "aspire.profileData.renderUnsavedChanges.closeModalAriaLabel",
                    defaultMessage: "Click to close the modal"
                  })}
                  className="icon-cross save-close-btn modal-close-button"
                  onClick={this.hideConfirmEditCloseModal}
                />
              </div>
              <div className="card-block-lg text-center">
                <div className="delete-modal-icon-row">
                  <div className="save-modal-icon-wrapper">
                    <img
                      className="save-modal-icon"
                      src={`${process.env.APP_BASE_URL}dist/images/ic_save_alert.svg`}
                      alt={this.props.intl.formatMessage({
                        id: "aspire.profileData.renderUnsavedChanges.alertIconAlt",
                        defaultMessage: "Alert icon"
                      })}
                    />
                  </div>
                </div>
                <div className="delete-modal-heading">
                  <FormattedMessage
                    id="aspire.profileData.renderUnsavedChanges.heading"
                    defaultMessage="Unsaved Changes"
                  />
                </div>
                <div className="delete-modal-subheading">
                  <FormattedMessage
                    id="aspire.profileData.renderUnsavedChanges.subheading"
                    defaultMessage="Do you want to save recent changes?"
                  />
                </div>
                <div className="delete-modal-btn-grp">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-discard"
                    aria-label={this.props.intl.formatMessage({
                      id: "aspire.profileData.renderUnsavedChanges.discardBtn",
                      defaultMessage: "Click to continue editing, Discard"
                    })}
                    onClick={() => this.hideEditModalActual()}>
                    <FormattedMessage
                      id="aspire.profileData.renderUnsavedChanges.discardBtn"
                      defaultMessage="Discard"
                    />
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-accept"
                    aria-label={this.props.intl.formatMessage({
                      id: "aspire.profileData.renderUnsavedChanges.saveBtn",
                      defaultMessage: "Click yes to remove the changes and close edit modal, Save"
                    })}
                    onClick={this.handleSaveChangesModal}>
                    <FormattedMessage
                      id="aspire.profileData.renderUnsavedChanges.saveBtn"
                      defaultMessage="Save"
                    />
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </FocusLock>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    editedSection: state.editData.section_name,
    editedSubSectionId: state.editData.sub_section_id,
    editedSectionDeleted: state.editData.delete_sub_section,
    processingStatus: state.aspireFeedbackData.status,
    section_wise_feedback: state.aspireFeedbackData.data.section_wise_feedback,
    savingChanges:
      !_.isEmpty(state.aspireFeedbackData.mini_loader_text) ||
      state.editData.uploading_edited_data,
    isUrlEditModal: state.editData.show_url_edit_modal,
    isEditModal: state.editData.show_edit_modal,
    activeEditModalSection: state.editData.active_edit_modal_section,
    show_log_modal: state.editData.show_log_modal,
  }
}

export default connect(mapStateToProps, {
  processEditedData,
  fetchPdf,
  updateText,
  showUrlEditModal,
  showEditModal,
  changeProfilePicInitialEditState,
  showLogModal,
})(injectIntl(ProfileData))